import getAspect from './getAspect';

export default getAspect;
